<template>
  <div class="container-fluid no-padding">
    <div class="row toolbox-fixed border-bottom">
      <div class="offset-md-2 col-md-8 mb-2 mt-2">
        <autocomplete id="customer-address" :inputClass="'loading'"
          v-model="searchFilter" :serializer="item => item.SEARCH_RESULT" :data="searchResult"
          placeholder="Müşteri adı, araç plakası ve ya seri numarası ile arama yapın..."
          @hit="selectSearchResult($event)">
          <template slot="suggestion" slot-scope="{ data, htmlText }">
            <div class="justify-content-between search-result">
              <h4 v-if="data.TYPE == 0" class="my-0 font-semi-bold">{{data.VEHICLE_NAME}} - <span class="text-muted">{{data.VEHICLE_LICENCE_TAG}}</span></h4>
              <h4 v-else-if="data.TYPE == 1" class="my-0 font-semi-bold">{{data.IMEI_NO}}</h4>
              <h4 v-else class="my-0 font-semi-bold">{{data.CUSTOMER_TITLE}} - <span class="text-muted">{{data.CUSTOMER_ID}}</span></h4>
              <small v-if="data.TYPE == 0" class="text-muted mr-1">{{data.IMEI_NO}}</small>
              <small v-if="data.TYPE == 1" class="text-muted mr-1">{{data.VEHICLE_NAME}}</small>
              <small v-if="data.TYPE == 0 || data.TYPE == 1" class="text-muted mr-1">&bull;</small>
              <small v-if="data.TYPE == 0 || data.TYPE == 1" class="text-muted mr-1">{{data.CUSTOMER_TITLE}}</small>
              <small v-if="data.TYPE == 0 || data.TYPE == 1" class="text-muted mr-1">&bull;</small>
              <small v-if="data.TYPE == 0 || data.TYPE == 1" class="text-muted">{{data.GROUP_NAME}}</small>
              <small v-if="data.TYPE == 0 || data.TYPE == 1" class="text-muted mr-1">&bull;</small>
              <small v-if="data.TYPE == 0 || data.TYPE == 1" class="text-muted">{{data.DEVICE_LABEL}}</small>
              <small v-if="data.TYPE == 2" class="text-muted">TÜM ARAÇLARI GÖSTER</small>
              <button class="btn btn-more-radius btn-sm btn-success float-right btn-top"
                @click="addSearchResult(data)">&hookrightarrow;&nbsp;&nbsp;Listeye Ekle</button>
            </div>
          </template>
        </autocomplete>
      </div>
    </div>
    <div class="row no-padding">
      <div class="col-md-4 p-0 border-right vlist">
        <v-wait for="items-loading">
          <template slot="waiting">
            <div class="vue-wait-class">
              <img src="static/loading.svg" />
              <p>Müşteri araçları yükleniyor...</p>
            </div>
          </template>
          <div class="list-group">
            <div class="justify-content-between py-3 px-4 list-group-item"
                :class="{'active' : selectedObject.IMEI_NO == data.IMEI_NO}"
                v-for="(data, index) in debuggingObjects" v-bind:key="'dbg-' + index" @click="selectItem(index)">
              <h4 v-if="data.TYPE == 0" class="my-0 font-semi-bold">{{data.VEHICLE_NAME}} - <span class="text-muted">{{data.VEHICLE_LICENCE_TAG}}</span></h4>
              <h4 v-else-if="data.TYPE == 1" class="my-0 font-semi-bold">{{data.IMEI_NO}}</h4>
              <small v-if="data.TYPE == 0" class="text-muted mr-1">{{data.IMEI_NO}}</small>
              <small v-if="data.TYPE == 1" class="text-muted mr-1">{{data.VEHICLE_NAME}}</small>
              <small class="text-muted mr-1">&bull;</small>
              <small class="text-muted mr-1">{{data.CUSTOMER_TITLE}}</small>
              <small class="text-muted mr-1">&bull;</small>
              <small class="text-muted">{{data.GROUP_NAME}}</small>
              <small class="text-muted mr-1">&bull;</small>
              <small class="text-muted clearfix">{{data.DEVICE_LABEL}}</small>
              <span class="badge badge-custom" :class="parseDataAsClass(data.CONNECTION, data.ENGINE, data.SATELITE)" >
                {{parseDataAsView(data.CONNECTION, data.ENGINE, data.SATELITE)}}</span>
              <span v-if="data.CONNECTION == 1" class="badge badge-custom" :class="{'badge-danger' : data.SATELITE == 0, 'badge-success' : data.SATELITE == 1 || data.SATELITE == 2}">
                {{data.SATELITE == 0 ? 'GPS BAĞLANTISI KESİK' : 'GPS BAĞLI'}}</span>
              <span class="badge badge-custom badge-dark"><i class="far fa-clock mr-2 text-white"></i>{{formatServerTime(data.SERVER_TIME)}}</span>
            </div>
          </div>
        </v-wait>
      </div>
      <div class="col-md-8 p-0">
        <div id="map"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment, { now } from 'moment'
import Datepicker from 'vuejs-datepicker'
import axios from 'axios'
import autocompl from 'vue-bootstrap-typeahead'
import vuetypeahead from 'vue-typeahead'

export default {
  name: 'ArizaKayitPage',
  components: {
    'datepicker': Datepicker,
    'autocomplete': autocompl,
    'typeahead': vuetypeahead
  },
  data () {
    return {
      searchFilter: '',
      searchResult: [],
      selectedObject : {},
      selectedIndex: -1,
      debuggingObjects: [],
      map: null,
      marker: null
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    async search() {
      if(!this.searchFilter || this.searchFilter.length < 4)
        return

      await axios
      .post('/api/debug/search?sessionid=' + this.getSessionId + '&searchFilter=' + this.searchFilter)
      .then(response => {
        this.searchResult = response.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    selectItem(index) {
      this.selectedIndex = index
      this.selectedObject = this.debuggingObjects[index]
      this.reflectMap(this.selectedObject.LATITUDE, this.selectedObject.LONGITUDE)
    },
    async getCustomerVehicles(id) {
      this.$wait.start('items-loading')
      await axios
      .post('/api/debug/get-vehicles?sessionid=' + this.getSessionId + '&customerid=' + id)
      .then(response => {
        this.debuggingObjects = response.data
      })
      .catch(error => {
        console.log(error)
      })
      this.$wait.end('items-loading')
    },
    async getState(imeiNo, type) {
      this.$wait.start('items-loading')
      await axios
      .post('/api/debug/get-state?sessionid=' + this.getSessionId + '&imeiNo=' + imeiNo + "&type=" + type)
      .then(response => {
        this.debuggingObjects = response.data
      })
      .catch(error => {
        console.log(error)
      })
      this.$wait.end('items-loading')
    },
    async updateList() {
      let imeis = this.debuggingObjects.map(m => m.IMEI_NO).join(',')
      console.log("Imeis first: " + this.debuggingObjects.length)
      let muconf = {
        'SessionId' : this.getSessionId,
        'ImeiNo': imeis,
        'GetType': 0
      }
      console.log(muconf)
      await axios
      .post('/api/debug/get-state-multiple', muconf)
      .then(response => {
        this.debuggingObjects = response.data
        console.log("Imeis second: " + response.data.length)
        if(this.selectedIndex > -1) {
          this.selectedObject = this.debuggingObjects[this.selectedIndex]
          this.reflectMap(this.selectedObject.LATITUDE, this.selectedObject.LONGITUDE)
        }
      })
      .catch(error => {
        console.log(error)
      })
      //setTimeout(() => this.updateList(), 15000)
    },
    selectSearchResult(obj) {
      if(obj.TYPE != 2) {
        this.debuggingObjects = []
        this.debuggingObjects.push(obj)
        this.getState(obj.IMEI_NO, obj.TYPE)
      } else {
        this.getCustomerVehicles(obj.CUSTOMER_ID)
      }
    },
    addSearchResult(obj) {
      console.log('butona click')
      if(obj.TYPE != 2) {
        this.debuggingObjects.push(obj)
        this.getState(obj.IMEI_NO, obj.TYPE)
      }
    },
    initMap() {
      let centerPosition = {lat:41.0938477,lng:29.0927507};
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: centerPosition,
        disableDefaultUI: true,
        draggable: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        zoom: 18
      });
    },
    reflectMap(latitude, longitude) {
      if(this.marker != null)
        this.marker.setMap(null)

      let latlng = {lat: parseFloat(latitude.toString().replace(',', '.')), 
        lng: parseFloat(longitude.toString().replace(',', '.'))}
      this.marker = new google.maps.Marker({
        position: latlng,
        map: this.map
      });

      this.map.setCenter(latlng)
    },
    key(e) {
      console.log('e.keyCode : ' + e.keyCode)
    },
    parseDataAsClass(conn, engine, satelite) {
      if(conn == 0) return 'badge-primary'
      if(conn == 2) return 'badge-secondary'
      if(conn == 1 && engine == 0) return 'badge-danger'
      if(conn == 1 && engine == 1) return 'badge-success'
    },
    parseDataAsView(conn, engine, satelite) {
      if(conn == 0) return 'BAĞLANTI KESİK'
      if(conn == 2) return 'UYKU MODUNDA'
      if(conn == 1 && engine == 0) return 'KONTAK KAPALI'
      if(conn == 1 && engine == 1) return 'KONTAK AÇIK'
    },
    formatServerTime(servertime) {
      return moment(servertime).fromNow()
    }
  },
  mounted() {
    moment.locale('tr')
    this.initMap()
    setTimeout(() => this.updateList(), 15000)
  },
  watch: {
    searchFilter: _.debounce(function(val) { this.search() }, 500),
  }
}
</script>

<style scoped>
  input[type="text"].loading {
    background-image: url("~/static/loading.svg");
    background-size: 32px 32px;
    background-position:right center;
    background-repeat: no-repeat;
  }
  .font-semi-bold {
    font-weight: 400;
  }
  .vbst-item:hover .search-result h4, .vlist .search-result:hover h4,
  .vlist .list-group-item:hover h4, .vlist .list-group-item.active h4 {
    color: white;
  }
  .vbst-item:hover .search-result h4 span, .vbst-item:hover .search-result small,
  .vlist .list-group-item:hover h4 span, .vlist .list-group-item:hover small,
  .vlist .list-group-item.active h4 span, .vlist .list-group-item.active small {
    color: #afcbf7 !important;
  }
  .vlist .list-group-item {
    border-radius: 0;
  }
  .vlist .list-group-item:hover {
    cursor: pointer;
    background-color: #007bff
  }
  .container, .container-fluid {
		height: calc(100vh - 80px) !important;
		min-height: 100% !important;
		overflow: hidden !important;
	}
	.vlist {
		padding-left: 0 !important;
		padding-right: 0 !important;
    display: inline-block !important;
    height: calc(100vh - 135px);
    max-height: 100% !important;
    overflow-y: auto;
	}
  #map {
    height: 100%;
    width: 100%;
    background-color: aqua;
  }
  .badge-custom {
    font-weight: 400;
    font-size: .75rem;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 4px;
  }
  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }
  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }
  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }
  .btn-top {
    z-index: 2;
    position: absolute;
    top: 15px;
    right: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/components/DebugPage.vue